import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ButtonPill } from 'components/shared/MuiExtensions';
import { setNotification } from 'state/app.state';
import { RootState } from 'state/store';
import { buildLeadComment, formatPhoneNumber } from 'utils/functions';
import { ReactComponent as CopyIcon } from 'assets/images/content_copy.svg';

const CopyLeadDetails = () => {
  const dispatch = useDispatch();

  const { firstName, lastName, phone, email, additionalNote } = useSelector(
    (state: RootState) => ({
      // TODO: UNI-6998: known issue, this does not update with unsaved changes
      firstName: state.lead.entity?.firstName,
      lastName: state.lead.entity?.lastName,
      phone: state.lead.entity?.phone,
      email: state.lead.entity?.email,
      additionalNote: state.lead.entity?.additionalNote,
    }),
    shallowEqual
  );

  const scriptResponseSummaryString = useSelector(
    (state: RootState) => state.script.scriptResponseSummaryString
  );

  const copyLeadDetails = () => {
    // navigator may not always have the clipboard property
    const navigator = window.navigator as any;

    // do we have the clipboard API?
    if (!navigator?.clipboard?.writeText) {
      dispatch(setNotification({ type: 'error', text: 'Could not copy lead details' }));
      return;
    }

    // build the contact details string
    const fullName = `${firstName ?? ''} ${lastName ?? ''}`.trim();
    const formattedPhone = phone ? formatPhoneNumber(phone) : null;
    const contactDetails = [fullName, formattedPhone, email].filter(Boolean).join('\n');

    // build the full lead details string
    const newLeadComment = buildLeadComment(
      additionalNote ?? '',
      scriptResponseSummaryString ?? ''
    );
    const leadDetails = [contactDetails, newLeadComment].filter(Boolean).join('\n\n');

    if (!leadDetails) {
      dispatch(setNotification({ type: 'error', text: 'No lead details to copy' }));
      return;
    }

    navigator.clipboard.writeText(leadDetails).then(
      () => dispatch(setNotification({ type: 'success', text: 'Lead details copied' })),
      () => dispatch(setNotification({ type: 'error', text: 'Could not copy lead details' }))
    );
  };

  return (
    <ButtonPill
      type="button"
      startIcon={<CopyIcon width="1rem" height="1rem" />}
      onClick={copyLeadDetails}
    >
      Copy Lead Details
    </ButtonPill>
  );
};

export default CopyLeadDetails;
